import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VueMoment from 'vue-moment'
import VueI18n from 'vue-i18n'
import VueD3 from 'vue-d3'
import ElementUI from 'element-ui'
import enLocale from 'element-ui/lib/locale/lang/en'
import './dark-theme/index.css'

import auth from './auth'

import App from './App'
import Login from './components/Login'
import Dashboard from './components/Dashboard'
import Overview from './components/Overview'
import Splash from './components/Splash'
import Surveillance from './components/Surveillance'
import Clients from './components/Clients'
import ClientService from './services/ClientService'

window.CONFIG = {}

window.CONFIG.api = 'http://52.60.162.95:8080'
window.CONFIG.host = 'http://52.60.162.95'
window.CONFIG.authHost = 'http://52.60.162.95:8082/auth'

// window.DEBUG = true
// if (window.DEBUG) {
//   window.CONFIG.host = 'http://localhost:8081'
//   window.CONFIG.api = 'http://localhost:8080'
//   window.CONFIG.authHost = 'http://localhost:8082/auth'
// }

window.CONFIG.loginCallbackUrl = window.CONFIG.host + '/token/'
window.CONFIG.authServerUrl = window.CONFIG.authHost + '/oauth/authorize?response_type=token&client_id=rest&redirect_uri=' + window.CONFIG.loginCallbackUrl

Vue.use(VueI18n)
Vue.use(VueResource)
Vue.use(ElementUI)
Vue.use(VueMoment)
Vue.use(VueD3)
Vue.use(VueRouter)
Vue.use(ClientService)

Vue.locale('en', enLocale)

Vue.http.headers.common['Access-Control-Allow-Origin'] = '*'
Vue.http.options.xhr = {withCredentials: true}
Vue.http.interceptors.push(function (request, next) {
  // modify method
  // request.method = 'POST'

  // modify headers
  // request.headers.set('X-CSRF-TOKEN', 'TOKEN')
  if (auth.loggedIn()) {
    request.headers.set('X-CSRF-TOKEN', auth.getToken())
    request.headers.set('Authorization', 'Bearer ' + auth.getToken())
  }

  request.headers.set('cache-control', 'no-cache')

  // console.log(JSON.stringify(request.headers, ' ', 1))
  // continue to next interceptor
  next(function (response) {
    if (response.status === 401) {
      auth.logout(function () {
        window.location = '/'
      })
    }
    return response
  })
})

function requireAuth (to, from, next) {
  if (!auth.loggedIn()) {
    window.location = window.CONFIG.authServerUrl
  } else {
    next()
  }
}

function getQueryVariable (query, variable) {
  var vars = query.split('&')
  var result = {}
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    result[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1])
  }

  return result
}

function updateToken (to, from, next) {
  // console.log('to: ' + JSON.stringify(to, ' ', 2))
  // console.log('from: ' + from)

  var tokenObj = getQueryVariable(to.hash.substring(1))
  console.log(JSON.stringify(tokenObj, ' ', 2))
  auth.updateTokens(tokenObj.access_token, tokenObj.refresh_token)
  next({
    path: '/'
  })
}

var router = new VueRouter({
  hashbang: false,
  mode: 'history',
  root: '/',
  routes: [
    { path: '/overview', component: Overview, beforeEnter: requireAuth },
    { path: '/splash', component: Dashboard, beforeEnter: requireAuth },
    { path: '/', component: Splash, beforeEnter: requireAuth },
    { path: '/surveillance', component: Surveillance, beforeEnter: requireAuth },
    { path: '/token', beforeEnter: updateToken },
    { path: '/login', component: Login },
    { path: '/clients', component: Clients, beforeEnter: requireAuth }
  ]
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router: router
})



// WEBPACK FOOTER //
// ./src/main.js